export default __webpack_public_path__ + "static/media/college.acd7c6ef.svg";